export const useGetLocale = () => {
    const locale = localStorage.getItem('locale');
    return { locale };
};
